const CalenderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 4.5H16.5V3.75C16.5 3.55109 16.421 3.36032 16.2803 3.21967C16.1397 3.07902 15.9489 3 15.75 3C15.5511 3 15.3603 3.07902 15.2197 3.21967C15.079 3.36032 15 3.55109 15 3.75V4.5H9V3.75C9 3.55109 8.92098 3.36032 8.78033 3.21967C8.63968 3.07902 8.44891 3 8.25 3C8.05109 3 7.86032 3.07902 7.71967 3.21967C7.57902 3.36032 7.5 3.55109 7.5 3.75V4.5H6.75C5.7558 4.50119 4.80267 4.89666 4.09966 5.59966C3.39666 6.30267 3.00119 7.2558 3 8.25L3 17.25C3.00119 18.2442 3.39666 19.1973 4.09966 19.9003C4.80267 20.6033 5.7558 20.9988 6.75 21H17.25C18.2442 20.9988 19.1973 20.6033 19.9003 19.9003C20.6033 19.1973 20.9988 18.2442 21 17.25V8.25C20.9988 7.2558 20.6033 6.30267 19.9003 5.59966C19.1973 4.89666 18.2442 4.50119 17.25 4.5ZM4.5 8.25C4.5 7.65326 4.73705 7.08097 5.15901 6.65901C5.58097 6.23705 6.15326 6 6.75 6H17.25C17.8467 6 18.419 6.23705 18.841 6.65901C19.2629 7.08097 19.5 7.65326 19.5 8.25V9H4.5V8.25ZM17.25 19.5H6.75C6.15326 19.5 5.58097 19.2629 5.15901 18.841C4.73705 18.419 4.5 17.8467 4.5 17.25V10.5H19.5V17.25C19.5 17.8467 19.2629 18.419 18.841 18.841C18.419 19.2629 17.8467 19.5 17.25 19.5Z"
        fill="var(--primary)"
        stroke="#FCFCFC"
        strokeWidth="0.3"
      />
      <path
        d="M12 15.375C12.6213 15.375 13.125 14.8713 13.125 14.25C13.125 13.6287 12.6213 13.125 12 13.125C11.3787 13.125 10.875 13.6287 10.875 14.25C10.875 14.8713 11.3787 15.375 12 15.375Z"
        fill="var(--primary)"
        stroke="#FCFCFC"
        strokeWidth="0.3"
      />
      <path
        d="M8.25024 15.375C8.87156 15.375 9.37524 14.8713 9.37524 14.25C9.37524 13.6287 8.87156 13.125 8.25024 13.125C7.62892 13.125 7.12524 13.6287 7.12524 14.25C7.12524 14.8713 7.62892 15.375 8.25024 15.375Z"
        fill="var(--primary)"
        stroke="#FCFCFC"
        strokeWidth="0.3"
      />
      <path
        d="M15.7498 15.375C16.3711 15.375 16.8748 14.8713 16.8748 14.25C16.8748 13.6287 16.3711 13.125 15.7498 13.125C15.1284 13.125 14.6248 13.6287 14.6248 14.25C14.6248 14.8713 15.1284 15.375 15.7498 15.375Z"
        fill="var(--primary)"
        stroke="#FCFCFC"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export default CalenderIcon;
